/**
 * CouponCode - 优惠码复制功能
 */
var CouponCode = {
  
  copied: false,
  timer: null,

  copy: function (codeinfo) {
    var self = this;
    var codeElement = document.getElementById('couponCode1');
    var code = codeElement ? codeElement.textContent.trim() : '';
    var code = codeinfo;
    if (!code) {
      alert('No coupon code available');
      return;
    }
    navigator.clipboard.writeText(code).then(function () {
      self.copied = true;
      var icon = document.getElementById('couponIcon');
      var text = document.getElementById('couponText');
      var btn = document.getElementById('btnCopyCoupon');

      if (icon) {
        icon.setAttribute('data-lucide', 'check');
        icon.classList.add('text-green-600');
      }
      if (text) text.textContent = 'Copied';

      if (self.timer) clearTimeout(self.timer);
      self.timer = setTimeout(function () {
        self.copied = false;
        if (icon) {
          icon.setAttribute('data-lucide', 'copy');
          icon.classList.remove('text-green-600');
        }
        if (text) text.textContent = 'Copy';
        if (typeof lucide !== 'undefined') lucide.createIcons();
      }, 2000);

      if (typeof lucide !== 'undefined') lucide.createIcons();
    }).catch(function () {
      alert('Failed to copy: ' + self.code);
    });
  }
};
